import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatTabChangeEvent, MatTabGroup, MatTab, MatTabLabel } from '@angular/material/tabs';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import * as compleWeb from '../../@store/complemento-web/complemento-web.actions';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { AppState } from 'src/app/@store/app.reducers';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ConsultaComplementoGeneralOutput, ConsultaSiniestroOutput } from 'src/app/models/complementos-web/complementos-web.model';
import { MatTableDataSource } from '@angular/material/table';
import { CrearActualizarTercerosComponent } from '../../@components/crear-actualizar-terceros/crear-actualizar-terceros.component';
import { ResultApiResponse } from '../../../../models/complementos-web/complementos-web-servicios.model';
import { CrearActualizaComplementoComponent } from '../../@components/crear-actualiza-complemento/crear-actualiza-complemento.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatCardActions } from '@angular/material/card';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-seccion-complemento',
    templateUrl: './seccion-complemento.component.html',
    styleUrls: ['./seccion-complemento.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTabGroup, MatTab, MatTabLabel, CrearActualizaComplementoComponent, CrearActualizarTercerosComponent, MatCardActions, MatButton]
})
export class SeccionComplementoComponent implements OnInit, OnDestroy {

  @ViewChild(CrearActualizaComplementoComponent) refComplemento: CrearActualizaComplementoComponent;
  @ViewChild(CrearActualizarTercerosComponent) refTerceros: CrearActualizarTercerosComponent;

  public tabIndex: number = 1;
  public catTabsComplementos = [
    { id: 1, nombre: 'General' },
    { id: 2, nombre: 'Terceros' },
  ];
  public siniestroConsultado: string;
  public detalleSeccionSiniestroComplemento: ConsultaComplementoGeneralOutput;
  private listaObservables = new Subscription();
  public detalleSiniestroComplemento: ConsultaSiniestroOutput;
  public tercerosComplemento = new MatTableDataSource([]);
  public validarTabTercero = false;

  constructor(
    public dialogRef: MatDialogRef<SeccionComplementoComponent>,
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    private procesosWebService: ProcesosComunesComplementoService,
    @Inject(MAT_DIALOG_DATA) public data: { siniestro: string },
  ) {
    this.obtenerReduxState();
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  ngOnInit(): void {

  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      this.siniestroConsultado = siniestro;
      this.detalleSiniestroComplemento = detalleSiniestro?.siniestroDetalle;
      this.consultarComplementoWeb(siniestro);
    });
    this.listaObservables.add(subsComplemento);
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close();
  }

  onTabChange(event: MatTabChangeEvent) {
    this.tabIndex = Number(event.index + 1);
    if (this.tabIndex == 2) {
      this.refTerceros.consultaTerceros();
    }
  }

  consultarComplementoWeb(siniestro: string) {
    const siniestroFormateado = this.procesosWebService.devolverSiniestro(siniestro);
    const request = {
      sucursal: this.detalleSiniestroComplemento.Siniestro[0].sucursalk1,
      linea: this.detalleSiniestroComplemento.Siniestro[0].cve_linea,
      producto: this.detalleSiniestroComplemento.Siniestro[0].cve_prod,
      poliza: this.detalleSiniestroComplemento.Siniestro[0].polizak1,
      endoso: this.detalleSiniestroComplemento.Siniestro[0].endosok1,
      a_emision: this.detalleSiniestroComplemento.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSiniestroComplemento.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSiniestroComplemento.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSiniestroComplemento.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSiniestroComplemento.Siniestro[0].num_incisok,
      num_depend: this.detalleSiniestroComplemento.Siniestro[0].num_dependk,
      fechaSiniestro: this.detalleSiniestroComplemento.Siniestro[0].fecsini,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      causa: this.detalleSiniestroComplemento.Siniestro[0].causa,
      tiposTercero: '',
      cobertura: 1,
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaComplementoGeneral(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado != null) {
          this.detalleSeccionSiniestroComplemento = value.Resultado;
          this.validarTercero();
          this.tercerosComplemento = new MatTableDataSource(this.detalleSeccionSiniestroComplemento.Terceros);
        } else {
          this.procesosWebService.alertaGeneralComplemento('Aviso', `No se encontró el detalle del siniestro.`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos del complemento.' }));
      },
    })
  }

  validarTercero() {
    switch ( this.detalleSiniestroComplemento.Siniestro[0].causa) {
      case 3:
      case 6:
        this.validarTabTercero = false;
        break;
    
      default:
        if (
          this.detalleSiniestroComplemento.Siniestro[0].serie != null &&
          this.detalleSiniestroComplemento.Siniestro[0].serie_normal == 1 &&
          this.detalleSiniestroComplemento.Siniestro[0].respons_sini != 0
        ) {
          this.validarTabTercero = true;
        }
        break;
    }
  }

  consultarSiniestro() {
    const siniestroFormateado = this.procesosWebService.devolverSiniestro(this.data.siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      siniestroCompleto: `${siniestroFormateado.siniestroCompleto}`,
    }
    this.store.dispatch(ActivarLoadingAction());

    this.complementoWebService.consultaSiniestro(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.procesaDetalleComplemento(value);
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos.' }));
      },
    })
  }

  guardarComplemento() {
    this.refComplemento.guardarComplemento();
  }

  procesaDetalleComplemento(siniestroDetalle: ResultApiResponse<ConsultaSiniestroOutput>) {
    const estatusSiniestro = siniestroDetalle.Resultado.Siniestro[0].estatus != 4;

    const perfilAdmin = siniestroDetalle.Resultado.perfil_administrador
    const responsabilidadSiniestro = [3, 6].includes(siniestroDetalle.Resultado.Siniestro[0].causa) && Number(perfilAdmin) == 0 ? 2 : siniestroDetalle.Resultado.Siniestro[0].respons_sini;
    const detalleSiniestro = {
      estatus: siniestroDetalle.Resultado.Siniestro[0].estatus,
      perfil: siniestroDetalle.Resultado.perfil,
      perfilAdministrador: perfilAdmin,
      siniestroDetalle: siniestroDetalle.Resultado,
      causa: siniestroDetalle.Resultado.Siniestro[0].causa,
      responsabilidad: responsabilidadSiniestro,
      siniestroCompleto: `${this.data.siniestro}`,
    }
    this.store.dispatch(compleWeb.EstablecerResultDetalleComplementoSVAction({ detalleComplemento: detalleSiniestro }));
  }

  procesaEventosComplemento(evento: { nombre: string, valor: any }) {
    if (evento.nombre == 'ACTUALIZAR_COMPLEMENTO') {
      this.consultarComplementoWeb(this.siniestroConsultado);
      this.consultarSiniestro();
    }
  }
}
